import { motion } from "framer-motion";
import { DIFFERENTIALS } from "../data/site";

export const Differentials = () => (
  <section id="diferenciais" data-testid="differentials-section" className="px-5 sm:px-10 py-20 lg:py-28">
    <div className="grid lg:grid-cols-12 gap-10 lg:gap-8">
      <div className="lg:col-span-4">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-ink-soft">( Diferenciais )</p>
        <h2 className="mt-4 font-display uppercase text-4xl sm:text-5xl leading-[0.95]">Por que empresas<br />escolhem <em className="text-alga whitespace-nowrap">a Alfa?</em></h2>
      </div>
      <div className="lg:col-span-8 grid sm:grid-cols-2 border-t border-ink/15">
        {DIFFERENTIALS.map((d, i) => (
          <motion.div
            key={d.n}
            data-testid={`differential-${d.n}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, delay: (i % 2) * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className={`group py-8 sm:py-10 border-b border-ink/15 ${i % 2 ? "sm:pl-8" : "sm:pr-8 sm:border-r"}`}
          >
            <span className="font-display text-alga text-lg">{d.n}</span>
            <h3 className="mt-3 font-display uppercase text-xl sm:text-2xl leading-tight">{d.title}</h3>
            <p className="mt-2 text-sm sm:text-base text-ink-soft leading-snug max-w-xs">{d.desc}</p>
            <span className="mt-6 block h-[2px] w-10 bg-ink transition-[width,background-color] duration-500 group-hover:w-20 group-hover:bg-alga" />
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
